// extracted by mini-css-extract-plugin
export default {"richTextareaWrapper":"RichTextarea_richTextareaWrapper__lGLhu","richTextarea":"RichTextarea_richTextarea__zIDD6"};